import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { ModalContext } from "components/ModalContext";
import { CSSTransition } from "react-transition-group";
import "./index.scss";

const Modal = ({
  onCloseModal,
}) => {
  const { 
    modalContent,
    handleModal, 
    modal,
  } = React.useContext(ModalContext);

  useEffect(() => {
    const body = document.body;
    
    modal
      ? (body.style.overflow = "hidden")
      : (body.style.overflow = "unset");
  }, [modal]);

  const handleCloseModal = (e) => {
    if (
      [...e.target.classList].includes('modal_wrap')
      || [...e.target.classList].includes('modal_close')
    ) {
      handleModal();
      onCloseModal();
    }
  };

  return ReactDOM.createPortal(
    <CSSTransition
      in={!!modal}
      timeout={300}
      classNames="modal_wrap"
      unmountOnExit
    >
      <div
        className="modal_wrap"
        onClick={handleCloseModal}
      >
        <div
          className="modal_content"
        >
          <button
            className="modal_close"
            onClick={handleCloseModal}
          >
            &times;
          </button>

          <div 
            className="modal_content_body"
          >
            {modalContent}
          </div>
        </div>
      </div>
    </CSSTransition>,
    document.querySelector("#modals")
  );
};

export default Modal;
